import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, ModuleFE_Toaster, SimpleListAdapter, TS_DropDown, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './Editor_NewPathway.scss';
import { PathwayTypes, PathwayTypeToLabel, PathwayVersions } from '@app/pathway-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { ModuleFE_Pathway } from '../../../../../_entity.js';
import { UtilObject_Pathway } from '../../../../../search/items/pathway.js';
export class Editor_NewPathway extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.newItemData = nextProps.newItemData;
        return state;
    }
    // ######################## Logic ########################
    onValueChange = (key, value) => {
        const newItemData = { ...(this.state.newItemData ?? {}) };
        newItemData[key] = value;
        this.props.workHubItem.updateArgs(this.props.tabId, { newItemData });
    };
    createPathway = async () => {
        const toCreate = {
            label: this.state.newItemData.label,
            type: this.state.newItemData.type,
            variableIds: [],
            tagGroups: [],
            underConstruction: true,
            scoreReferences: [],
            version: PathwayVersions[PathwayVersions.length - 1],
            _tagIds: [],
            _variableIds: [],
        };
        try {
            const newPathway = await ModuleFE_Pathway._v1.createPathway({ ...toCreate }).executeSync();
            this.props.workHubItem.closeTab(this.props.tabId);
            UtilObject_Pathway.openEditor(newPathway.pathway);
        }
        catch (err) {
            this.logError('Failed creating pathway', err);
            ModuleFE_Toaster.toastError('Failed creating new pathway');
        }
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'editor__new-pathway', children: [_jsx("h1", { children: "New Pathway" }), this.render_Label(), this.render_PathwayType(), this.render_Create()] });
    }
    render_Label = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(TS_Input, { type: 'text', value: this.state.newItemData?.label, onBlur: value => this.onValueChange('label', value) }) });
    };
    render_PathwayType = () => {
        const adapter = SimpleListAdapter([...PathwayTypes], type => _jsx(_Fragment, { children: PathwayTypeToLabel[type.item] }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Type', children: _jsx(TS_DropDown, { adapter: adapter, selected: this.state.newItemData?.type, caret: DropDown_DefaultCaret, onSelected: type => this.onValueChange('type', type) }) });
    };
    render_Create = () => {
        return _jsx(Button, { variant: 'primary', onClick: this.createPathway, children: "Create Pathway" });
    };
}
//# sourceMappingURL=Editor_NewPathway.js.map